import TwoFactorDisable from './TwoFactorDisable';

export default TwoFactorDisable;
